import { takeLatest, takeEvery } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import * as Global from './global';
import * as Auth from './auth';
import * as Profile from './profile';
import * as User from './users';
import * as Team from './teams';
import * as Agreement from './agreements';
import * as Work from './works';
import * as WorkOwnership from './workOwnerships';
import * as Deal from './deals';
import * as Invite from './invites';
import * as DealMessage from './dealMessages';
import * as DealUser from './dealUsers';
import * as Coreg from './coreg';
import * as Payment from './payment';
import * as Publisher from './publishers';

export function* watchers() {
  yield takeLatest(actionTypes.AUTH_LOGIN_REQUEST, Auth.login);
  yield takeLatest(actionTypes.AUTH_SIGNUP_REQUEST, Auth.signup);
  yield takeLatest(actionTypes.AUTH_FORGOT_REQUEST, Auth.forgot);
  yield takeLatest(actionTypes.AUTH_EMAIL_REQUEST, Auth.retrieveEmail);
  yield takeLatest(actionTypes.AUTH_RESET_REQUEST, Auth.resetPassword);
  yield takeLatest(
    actionTypes.AUTH_CONFIRM_EMAIL_REQUEST,
    Auth.getConfirmEmail
  );
  yield takeLatest(
    actionTypes.AUTH_VERIFY_EMAIL_REQUEST,
    Auth.verifyEmailByToken
  );
  yield takeLatest(
    actionTypes.RESEND_CONFIRMATION_LINK_REQUEST,
    Auth.resendConfirmationLink
  );

  yield takeLatest(actionTypes.PROFILE_GET_REQUEST, Profile.getProfile);
  yield takeLatest(actionTypes.PROFILE_UPDATE_REQUEST, Profile.updateProfile);
  yield takeLatest(actionTypes.USER_UPDATE_REQUEST, User.updateUser);
  yield takeLatest(actionTypes.USER_GET_REQUEST, User.getUser);
  yield takeLatest(actionTypes.PASSWORD_CHANGE_REQUEST, Profile.changePassword);

  yield takeLatest(actionTypes.USERS_WITH_REFERRER_ID_GET_REQUEST, User.getUsersWithReferrerID);

  yield takeLatest(actionTypes.ROLES_GET_REQUEST, Global.getRoles);
  yield takeLatest(
    actionTypes.OWNERSHIP_TYPES_GET_REQUEST,
    Global.getOwnershipTypes
  );
  yield takeLatest(
    actionTypes.CONTRACT_BLOCKS_GET_REQUEST,
    Global.getContractBlocks
  );
  yield takeLatest(actionTypes.WORK_TYPES_GET_REQUEST, Global.getWorkTypes);
  yield takeLatest(
    actionTypes.SUBWORK_TYPES_GET_REQUEST,
    Global.getSubWorkTypes
  );

  yield takeLatest(actionTypes.TEAMS_GET_REQUEST, Team.getTeams);
  yield takeLatest(actionTypes.TEAM_GET_REQUEST, Team.getTeam);
  yield takeLatest(actionTypes.TEAM_CREATE_REQUEST, Team.createTeam);
  yield takeLatest(actionTypes.TEAM_UPDATE_REQUEST, Team.updateTeam);
  yield takeLatest(actionTypes.TEAM_DELETE_REQUEST, Team.deleteTeam);
  yield takeLatest(actionTypes.TEAM_ARCHIVE_REQUEST, Team.archiveTeam);
  yield takeLatest(actionTypes.TEAM_RECOVER_REQUEST, Team.recoverTeam);

  yield takeLatest(actionTypes.MEMBERS_GET_REQUEST, User.getTeamMembers);
  yield takeLatest(actionTypes.MEMBER_CREATE_REQUEST, User.createTeamMember);
  yield takeEvery(actionTypes.MEMBER_UPDATE_REQUEST, User.updateTeamMember);
  yield takeEvery(actionTypes.MEMBER_DELETE_REQUEST, User.deleteTeamMember);

  yield takeEvery(actionTypes.OWNERSHIP_CREATE_REQUEST, User.createOwnership);
  yield takeEvery(actionTypes.OWNERSHIP_UPDATE_REQUEST, User.updateOwnership);
  yield takeEvery(actionTypes.OWNERSHIP_DELETE_REQUEST, User.deleteOwnership);

  yield takeLatest(actionTypes.AGREEMENTS_GET_REQUEST, Agreement.getAgreements);
  yield takeLatest(actionTypes.AGREEMENT_GET_REQUEST, Agreement.getAgreement);
  yield takeLatest(
    actionTypes.AGREEMENT_CREATE_REQUEST,
    Agreement.createAgreement
  );
  yield takeLatest(
    actionTypes.AGREEMENT_UPDATE_REQUEST,
    Agreement.updateAgreement
  );
  yield takeLatest(
    actionTypes.AGREEMENT_DELETE_REQUEST,
    Agreement.deleteAgreement
  );

  yield takeLatest(
    actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_REQUEST,
    Agreement.getAgreementContractBlocks
  );
  yield takeEvery(
    actionTypes.AGREEMENT_CONTRACT_BLOCK_SAVE_REQUEST,
    Agreement.saveAgreementContractBlock
  );

  yield takeLatest(
    actionTypes.AGREEMENT_SENTENCE_CREATE_REQUEST,
    Agreement.createAgreementSentence
  );
  yield takeLatest(
    actionTypes.AGREEMENT_SENTENCE_UPDATE_REQUEST,
    Agreement.updateAgreementSentence
  );

  yield takeLatest(actionTypes.USER_WORKS_GET_REQUEST, Work.getUserWorks);
  yield takeLatest(actionTypes.WORK_GET_REQUEST, Work.getWork);
  yield takeLatest(actionTypes.WORK_CREATE_REQUEST, Work.createWork);
  yield takeLatest(actionTypes.WORK_UPDATE_REQUEST, Work.updateWork);
  yield takeLatest(actionTypes.WORK_DELETE_REQUEST, Work.deleteWork);

  yield takeEvery(
    actionTypes.WORK_OWNERSHIPS_GET_REQUEST,
    WorkOwnership.getWorkOwnerships
  );
  yield takeLatest(
    actionTypes.WORK_OWNERSHIP_GET_REQUEST,
    WorkOwnership.getWorkOwnership
  );
  yield takeEvery(
    actionTypes.WORK_OWNERSHIP_CREATE_REQUEST,
    WorkOwnership.createWorkOwnership
  );
  yield takeEvery(
    actionTypes.WORK_OWNERSHIP_UPDATE_REQUEST,
    WorkOwnership.updateWorkOwnership
  );
  yield takeLatest(
    actionTypes.WORK_OWNERSHIP_DELETE_REQUEST,
    WorkOwnership.deleteWorkOwnership
  );

  yield takeLatest(actionTypes.DEALS_GET_REQUEST, Deal.getDeals);
  yield takeLatest(actionTypes.DEAL_GET_REQUEST, Deal.getDeal);
  yield takeLatest(actionTypes.DEAL_CREATE_REQUEST, Deal.createDeal);
  yield takeLatest(actionTypes.DEAL_UPDATE_REQUEST, Deal.updateDeal);
  yield takeLatest(actionTypes.DEAL_DELETE_REQUEST, Deal.deleteDeal);
  yield takeLatest(actionTypes.DEALS_USER_GET_REQUEST, Deal.getUserDeals);
  yield takeLatest(
    actionTypes.FINALIZED_DEALS_GET_REQUEST,
    Deal.getFinalizedDeals
  );

  yield takeLatest(actionTypes.INVITES_GET_REQUEST, Invite.getInvites);
  yield takeLatest(actionTypes.INVITE_GET_REQUEST, Invite.getInvite);
  yield takeEvery(actionTypes.INVITE_CREATE_REQUEST, Invite.createInvite);
  yield takeLatest(actionTypes.INVITE_UPDATE_REQUEST, Invite.updateInvite);
  yield takeLatest(actionTypes.INVITE_DELETE_REQUEST, Invite.deleteInvite);
  yield takeLatest(
    actionTypes.INVITE_GET_BY_KEY_REQUEST,
    Invite.getInviteByKey
  );
  yield takeLatest(actionTypes.INVITES_USER_GET_REQUEST, Invite.getUserInvites);
  yield takeLatest(
    actionTypes.RESEND_DEAL_INVITATION_REQUEST,
    Invite.resendDealInvitation
  );

  yield takeLatest(actionTypes.DEAL_CHANGES_GET_REQUEST, Deal.getDealChanges);
  yield takeLatest(actionTypes.DEAL_CHANGE_GET_REQUEST, Deal.getDealChange);
  yield takeEvery(
    actionTypes.DEAL_CHANGE_CREATE_REQUEST,
    Deal.createDealChange
  );
  yield takeEvery(
    actionTypes.DEAL_CHANGE_UPDATE_REQUEST,
    Deal.updateDealChange
  );
  yield takeLatest(
    actionTypes.DEAL_CHANGE_DELETE_REQUEST,
    Deal.deleteDealChange
  );
  yield takeLatest(
    actionTypes.DEAL_CHANGE_NOTIFY_REQUEST,
    Deal.notifyDealChange
  );
  yield takeLatest(
    actionTypes.DEAL_INVITEE_CHANGE_EMAIL_REQUEST,
    Deal.sendEmailToInviteeDealChange
  );

  yield takeLatest(
    actionTypes.DEAL_MESSAGES_GET_REQUEST,
    DealMessage.getDealMessages
  );
  yield takeLatest(
    actionTypes.DEAL_MESSAGE_SEND_REQUEST,
    DealMessage.sendDealMessage
  );
  yield takeLatest(
    actionTypes.DEAL_MESSAGE_UPDATE_REQUEST,
    DealMessage.updateDealMessage
  );
  yield takeLatest(
    actionTypes.DEAL_MESSAGE_DELETE_REQUEST,
    DealMessage.deleteDealMessage
  );

  yield takeLatest(actionTypes.DEAL_USERS_GET_REQUEST, DealUser.getDealUsers);
  yield takeLatest(actionTypes.DEAL_USER_GET_REQUEST, DealUser.getDealUser);
  yield takeEvery(
    actionTypes.DEAL_USER_CREATE_REQUEST,
    DealUser.createDealUser
  );
  yield takeLatest(
    actionTypes.DEAL_USER_UPDATE_REQUEST,
    DealUser.updateDealUser
  );
  yield takeLatest(
    actionTypes.DEAL_USER_DELETE_REQUEST,
    DealUser.deleteDealUser
  );

  yield takeLatest(actionTypes.COREG_CREATE_REQUEST, Coreg.createCoreg);
  yield takeLatest(actionTypes.COREG_UPDATE_REQUEST, Coreg.updateCoreg);
  yield takeLatest(
    actionTypes.COREG_FILE_CREATE_REQUEST,
    Coreg.createCoregFile
  );
  yield takeLatest(
    actionTypes.COREG_TEMP_CREATE_REQUEST,
    Coreg.createCoregTemp
  );

  yield takeLatest(
    actionTypes.PAYMENT_CLIENT_TOKEN_REQUEST,
    Payment.getClientToken
  );
  yield takeLatest(actionTypes.PAYMENT_CHECKOUT_REQUEST, Payment.checkout);
  yield takeLatest(
    actionTypes.PAYMENT_GET_CUSTOMER_REQUEST,
    Payment.getCustomer
  );
  yield takeLatest(
    actionTypes.PAYMENT_GET_SUBSCRIBE_REQUEST,
    Payment.getSubscription
  );
  yield takeLatest(actionTypes.PAYMENT_SUBSCRIBE_REQUEST, Payment.subscribe);
  yield takeLatest(
    actionTypes.PAYMENT_CANCEL_SUBSCRIBE_REQUEST,
    Payment.cancelSubscribe
  );
  yield takeLatest(actionTypes.PAYMENT_TRANSACTION_REQUEST, Payment.pay);

  yield takeLatest(actionTypes.PHONE_VERIFY_REQUEST, Profile.verifyPhone);
  yield takeLatest(
    actionTypes.PHONE_VERIFY_CHECK_REQUEST,
    Profile.checkPhoneVerify
  );

  yield takeLatest(actionTypes.PUBLISHERS_GET_REQUEST, Publisher.getPublishers);
  yield takeEvery(
    actionTypes.PUBLISHER_CREATE_REQUEST,
    Publisher.createPublisher
  );
  yield takeEvery(
    actionTypes.PUBLISHER_UPDATE_REQUEST,
    Publisher.updatePublisher
  );
  yield takeEvery(
    actionTypes.PUBLISHER_DELETE_REQUEST,
    Publisher.deletePublisher
  );

  yield takeLatest(
    actionTypes.GET_MARKETING_CONTENT_REQUEST,
    Profile.getMarketingContent
  );
  yield takeLatest(
    actionTypes.CREATE_MARKETING_CONTENT_REQUEST,
    Profile.createMarketingContent
  );
  yield takeLatest(
    actionTypes.UPDATE_MARKETING_CONTENT_REQUEST,
    Profile.updateMarketingContent
  );
  yield takeLatest(
    actionTypes.FIX_AGREEMENT_INVITE_ISSUE_REQUEST,
    Profile.fixAgreementInviteIssue
  );
}



// WEBPACK FOOTER //
// src/redux/sagas/watchers.js